import { useFetchClient } from "@@/shared/fetch-client";
import {
    useTanstackSingleSuspenseQuery,
    type TanstackQueryOptions,
    type TanstackSuspenseQueryOptions,
} from "@@/shared/hooks/use-tanstack-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import type { GetResponse, Provider, ProviderIdOrSlug } from "@towni/common";
import { useMemo } from "react";

// const useProvider2 = (
//     providerIdOrSlug: ProviderIdOrSlug | undefined,
//     options: TanstackQueryOptions<Provider[]> = {},
// ): readonly [Provider | undefined, UseQueryResult<Provider, Error>]  => {
//     const query = useTanstackMultiQuery<Provider>(
//         `/providers/${encodeURIComponent(providerIdOrSlug ?? "")}`,
//         ["providers", providerIdOrSlug],
//         options,
//     );

//     // backwards compatibility, haven't got time
//     // to update all places it's used to just be contempt
//     // with query as result
//     const result = useMemo(() => {
//         return [query.data?.[0], query] as const;
//     }, [query]);

//     return result;
// };

const useProvider = (
    providerIdOrSlug: ProviderIdOrSlug | undefined,
    options: TanstackQueryOptions<Provider> = {},
): readonly [Provider | undefined, UseQueryResult<Provider, Error>] => {
    const fetchClient = useFetchClient();
    const enabled = !!providerIdOrSlug && options.enabled !== false;
    const queryKey = ["providers", providerIdOrSlug];
    const queryResult = useQuery<Provider>({
        ...options,
        enabled,
        queryKey,
        queryFn: async () => {
            const result = await fetchClient.get<GetResponse<Provider>>({
                route: `/providers/${encodeURIComponent(
                    providerIdOrSlug ?? "",
                )}`,
            });
            return result?.items?.[0] || null;
        },
    });
    const output = useMemo(() => {
        const output = [queryResult.data || undefined, queryResult] as const;
        return output;
    }, [queryResult]);

    return output;
};

const useProviderSuspenseQuery = (
    providerIdOrSlug: ProviderIdOrSlug | undefined,
    options: TanstackSuspenseQueryOptions<Provider> = {},
) => {
    const _providerIdOrSlug = encodeURIComponent(providerIdOrSlug ?? "");
    return useTanstackSingleSuspenseQuery<Provider>(
        `/providers/${_providerIdOrSlug}`,
        ["providers", providerIdOrSlug],
        { ...options, disabled: !providerIdOrSlug },
    );
};

export { useProvider, useProviderSuspenseQuery };
